import Slide1Img from "../assets/images/slide1.png";
import Slide2Img from "../assets/images/slide2.png";
import Slide3Img from "../assets/images/slide3.png";
import WhyChooseImg from "../assets/images/why-choose.png";
import VisitImg from "../assets/images/visit.png";
import HousePlanImg from "../assets/images/house-plan.png";
import PeaceImg from "../assets/images/peace.png";
import AmenitiesImg from "../assets/images/amenities.png";
import Property1Img from "../assets/images/property1.png";
import Property2Img from "../assets/images/property2.png";
import Property3Img from "../assets/images/property3.png";
import Property4Img from "../assets/images/property4.png";
import Property5Img from "../assets/images/property5.png";
import Property6Img from "../assets/images/property6.png";
import Property7Img from "../assets/images/property7.png";
import CartBackImg from "../assets/images/cart-back.png";
import UserImg from "../assets/images/user.png";
import TelePhoneImg from "../assets/images/telephone.png";
import MailMessageImg from "../assets/images/mailmessage.png";
import InstaImg from "../assets/images/instagram.png";
import TwitterImg from "../assets/images/twitter.png";

const staticContentImages = {
  "slide1.png": Slide1Img,
  "slide2.png": Slide2Img,
  "slide3.png": Slide3Img,
  "why-choose.png": WhyChooseImg,
  "visit.png": VisitImg,
  "house-plan.png": HousePlanImg,
  "peace.png": PeaceImg,
  "amenities.png": AmenitiesImg,
  "property1.png": Property1Img,
  "property2.png": Property2Img,
  "property3.png": Property3Img,
  "property4.png": Property4Img,
  "property5.png": Property5Img,
  "property6.png": Property6Img,
  "property7.png": Property7Img,
  "cart-back.png": CartBackImg,
  "user.png": UserImg,
  "telephone.png": TelePhoneImg,
  "mailmessage.png": MailMessageImg,
  "instagram.png": InstaImg,
  "twitter.png": TwitterImg,
};

export const getStaticContentImage = (filename, fallback = "") =>
  staticContentImages[filename] || fallback;
